import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { getProducts, productApi } from "../../helpers/product";
import ProductGridSingleTwo from "../../components/product/ProductGridSingleTwo";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist, deleteFromWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";

const ProductGridTwo = ({
  products,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItems,
  wishlistItems,
  deleteFromWishlist,
  compareItems,
  sliderClassName,
  spaceBottomClass,
  colorClass,
  titlePriceClass,
  type
}) => {
  const [productData, setProductData] = useState([]);
  useEffect(() => {
    if (type === 'new') {
      productApi.getProductsList(0, 6, [{ "key": "data.productOptions.featuredProduct", "operation": "eq", "value": "New" }, { "key": 'data.productOptions.activeProduct', "operation": "eq", "value": "true" }], ["productData.productName", "productData.productBrand", "productData.primaryImageUrl", "productData.colors", "productData.description", "productData.minimumPartPrice", "productOptions.featuredProduct"], []).then((response) => {
        setProductData(response.data.items);
      })
    } if (type === 'bestSeller') {
      productApi.getProductsList(0, 6, [{ "key": "data.productOptions.featuredProduct", "operation": "eq", "value": "Best Seller" }, { "key": 'data.productOptions.activeProduct', "operation": "eq", "value": "true" }], ["productData.productName", "productData.productBrand", "productData.primaryImageUrl", "productData.colors", "productData.description", "productData.minimumPartPrice", "productOptions.featuredProduct"], []).then((response) => {
        setProductData(response.data.items);
      })
    }
    if (type === 'saleItems') {
      productApi.getProductsList(0, 6, [{ key: "data.productOptions.featuredProduct", operation: "eq", value: 'Featured' }, { "key": 'data.productOptions.activeProduct', "operation": "eq", "value": "true" }], ["productData.productName", "productData.productBrand", "productData.primaryImageUrl", "productData.colors", "productData.description", "productData.minimumPartPrice", "productOptions.featuredProduct"], []).then((response) => {
        setProductData(response.data.items);
      })
    }
    if (type === "onSaleItems") {
      productApi.getProductsList(0, 6, [{ key: "data.productOptions.featuredProduct", operation: "eq", value: 'On Sale' }, { "key": 'data.productOptions.activeProduct', "operation": "eq", "value": "true" }], ["productData.productName", "productData.productBrand", "productData.primaryImageUrl", "productData.colors", "productData.description", "productData.minimumPartPrice", "productOptions.featuredProduct"], []).then((response) => {
        setProductData(response.data.items);
      })
    }
  }, [type]);

  return (
    <Fragment>
      {productData?.map((product) => {
        return (
          <ProductGridListSingle
            sliderClassName={sliderClassName}
            spaceBottomClass={spaceBottomClass}
            colorClass={colorClass}
            product={product}
            currency={currency}
            addToCart={addToCart}
            addToWishlist={addToWishlist}
            deleteFromWishlist={deleteFromWishlist}
            addToCompare={addToCompare}
            cartItem={
              cartItems.filter((cartItem) => cartItem.id === product.id)[0]
            }
            wishlistItem={
              wishlistItems.filter(
                (wishlistItem) => wishlistItem.id === product.id
              )[0]
            }
            compareItem={
              compareItems.filter(
                (compareItem) => compareItem.id === product.id
              )[0]
            }
            key={product.id}
            titlePriceClass={titlePriceClass}
          />
        );
      })}
    </Fragment>
  );
};

ProductGridTwo.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  deleteFromWishlist: PropTypes.func,
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  products: PropTypes.array,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItems: PropTypes.array
};

const mapStateToProps = (state, ownProps) => {
  return {
    currency: state.currencyData,
    cartItems: state.cartData,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize
        )
      );
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
    deleteFromWishlist: (item, addToast) => {
      dispatch(deleteFromWishlist(item, addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGridTwo);
